import {
  fetchCityActivityFaq,
  fetchItineraryHPFaq,
  fetchItineraryLandingPageFaq,
  fetchLayerFaq
} from '../../dataSource/seo/seo.request'
import { setSeoFaqData } from './seoSlice'

export const loadSeoItineraryHPFaq = mode => dispatch =>
  fetchItineraryHPFaq({ mode }).then(response => dispatch(setSeoFaqData(response)))

export const loadSeoCityActivityFaq = rubricId => dispatch =>
  fetchCityActivityFaq({ rubricId }).then(response => dispatch(setSeoFaqData(response)))

export const loadSeoLayerFaq = pageKey => dispatch =>
  fetchLayerFaq({ pageKey }).then(response => dispatch(setSeoFaqData(response)))

export const loadSeoItineraryLandingPageFaq = mode => dispatch =>
  fetchItineraryLandingPageFaq({ mode }).then(response => dispatch(setSeoFaqData(response)))
